module.exports = __webpack_public_path__ + "static/media/BMW.6c1c120d.svg";